/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface AccountForgotPassword
 */
export interface AccountForgotPassword {
    /**
     * 
     * @type {string}
     * @memberof AccountForgotPassword
     */
    email: string;
}

export function AccountForgotPasswordFromJSON(json: any): AccountForgotPassword {
    return {
        'email': json['email'],
    };
}

export function AccountForgotPasswordToJSON(value?: AccountForgotPassword): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'email': value.email,
    };
}


